import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedDataAccessParsersModule } from '@se-po/shared-data-access-parsers'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeTranslationsModule } from 'se-fe-translations'

import { SeFeAvatarModule } from 'se-fe-avatar'
import { SeFeHeaderModule } from 'se-fe-header'
import { PersonaChoiceComponent } from './persona-choice/persona-choice.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAvatarModule,
    SeFeButtonModule,
    SeFeHeaderModule,
    SeFeTranslationsModule,
    SharedDataAccessParsersModule
  ],
  declarations: [PersonaChoiceComponent],
  exports: [PersonaChoiceComponent],
  providers: [DatePipe, TitleCasePipe]
})
export class SharedUiPersonaChoiceModule {}
